export default __webpack_public_path__ + "static/media/dot-shadow.5e540849.svg";